import { createSelector, createSlice } from "@reduxjs/toolkit"
import { hotelsService } from "../../services/admin/hotels"

const initialState = {
  data: {},
}

const hotelsSlice = createSlice({
  name: "hotels",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addMatcher(hotelsService.endpoints.getHotels.matchFulfilled, (state, action) => {
      const { hotels = [], page } = action.payload
      if (!page || page === 1) {
        state.data = action.payload
      } else {
        state.data = {
          ...action.payload,
          hotels: [...(state.data.hotels ?? []), ...hotels],
        }
      }
    })
  },
})

const selectHotelsState = (state) => state.hotels

export const {} = hotelsSlice.actions

export const selectHotels = createSelector([selectHotelsState], (state) => state.data)

export default hotelsSlice.reducer
